import { FC, useEffect, useRef } from 'react'
import * as css from './Modal.css'

type PropTypes = {
  show?: boolean
  onClosed: () => void
  children: JSX.Element | JSX.Element[]
  className?: string
}

const Modal: FC<PropTypes> = ({ show, onClosed, children, className }) => {
  const modalElement = useRef(null)

  useEffect(() => {
    if (show && modalElement.current) {
      modalElement.current.focus()
    }
  }, [show])

  return (
    <div className={`${css.overlay} ${show ? css.visible : css.hidden}`} role="dialog" aria-modal="true" ref={modalElement} tabIndex={-1}>
      <div className={`${css.contentContainer} ${className}`}>
        <button className={`${css.closeButton} noEffects`} onClick={() => onClosed()}>
          &#x2715;
        </button>
        {children}
      </div>
    </div>
  )
}

export default Modal
